import React from 'react';
import { X } from 'lucide-react';

const ConsumptionDetailModal = ({ isOpen, onClose, task }) => {
    if (!isOpen || !task) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            ></div>

            {/* Modal Content */}
            <div className="relative bg-white w-full max-w-3xl rounded-[32px] shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                {/* Header */}
                <div className="p-8 pb-4 border-b border-gray-100 relative">
                    <button
                        onClick={onClose}
                        className="absolute right-6 top-6 p-1 rounded-full hover:bg-gray-100 transition-colors text-gray-400"
                    >
                        <X size={20} />
                    </button>
                    <h2 className="text-xl font-bold text-gray-900 mb-1">{task.name}</h2>
                    <p className="text-sm text-gray-400 font-medium">{task.tower}</p>
                </div>

                {/* Table Header */}
                <div className="px-8 py-4 bg-white flex justify-between text-[10px] font-bold text-gray-400 uppercase tracking-widest border-b border-gray-50">
                    <div className="w-[45%]">MATERIAL</div>
                    <div className="w-[35%] text-center">PLANNED / CONSUMED</div>
                    <div className="w-[20%] text-right">USAGE %</div>
                </div>

                {/* Material List */}
                <div className="px-8 max-h-[60vh] overflow-y-auto custom-scrollbar">
                    <div className="divide-y divide-gray-50">
                        {task.allMaterials?.map((material, idx) => (
                            <div key={idx} className="flex items-center justify-between py-4 hover:bg-gray-50/50 transition-colors px-2 rounded-xl">
                                {/* Material Name */}
                                <div className="w-[45%] flex items-center gap-3">
                                    <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${material.status === 'danger' ? 'bg-red-500' : material.status === 'warning' ? 'bg-orange-500' : 'bg-gray-300'}`}></div>
                                    <span className="text-sm font-bold text-gray-700">{material.name}</span>
                                </div>

                                {/* Quantities */}
                                <div className="w-[35%] text-center text-sm font-medium flex items-center justify-center gap-2">
                                    <span className="text-gray-400">{material.planned}</span>
                                    <span className="text-gray-300">/</span>
                                    <span className={`${material.status === 'danger' ? 'text-red-500' : material.status === 'warning' ? 'text-orange-500' : 'text-gray-400'} font-bold`}>
                                        {material.consumed}
                                    </span>
                                    <span className="text-gray-400 text-[10px] font-normal ml-0.5">{material.unit}</span>
                                </div>

                                {/* Usage */}
                                <div className="w-[20%] text-right">
                                    <span className={`text-lg font-bold ${material.status === 'danger' ? 'text-red-500' : material.status === 'warning' ? 'text-orange-500' : 'text-gray-400'}`}>
                                        {material.usage}%
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer Padding */}
                <div className="h-10"></div>
            </div>

            <style>{`
                .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: #f8fafc;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #e2e8f0;
                    border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #cbd5e1;
                }
            `}</style>
        </div>
    );
};

export default ConsumptionDetailModal;
